import React, {Component} from 'react';
import './FancyCheckbox.css';

class FancyCheckbox extends Component {
	constructor() {
		super();

		this.onChange = () =>
			this.props.onChange && this.props.onChange({target: {checked: !this.props.checked}});
	}

	render() {
		const {checked, onChange, title} = this.props;

		return (
			<div
				className={`FancyCheckbox ${checked ? 'checked' : ''}`}
				onClick={this.onChange}
				title={title}>
				<div className="FancyCheckbox-slider" />
			</div>
		);
	}
}

export default FancyCheckbox;



// WEBPACK FOOTER //
// ./src/widgets/FancyCheckbox.js